import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ImagenFirma } from "./ImagenFirma";
import styles from "../../shared/Evaluaciones.module.css";

export function FirmasEvaluacion({ evaluacion, onFirmar }) {
  const firmas = [
    {
      rol: "Empleado",
      usuarioID: evaluacion.usuarioEmpleadoID,
      url: evaluacion.urlFirmaUsuarioEmpleado,
      campo: "FirmaUsuarioEmpleado",
      tipoFirma: 1,
    },
    {
      rol: "Supervisor",
      usuarioID: evaluacion.usuarioSupervisorID,
      url: evaluacion.urlFirmaUsuarioSupervisor,
      campo: "FirmaUsuarioSupervisor",
      tipoFirma: 2,
    },
    {
      rol: "Analista de calidad",
      usuarioID: evaluacion.usuarioAnalistaID,
      url: evaluacion.urlFirmaUsuarioAnalistaCalidad,
      campo: "FirmaUsuarioAnalistaCalidad",
      tipoFirma: 3,
    },
  ].filter(firma => firma.url !== null || evaluacion.calificacion !== null);

  if (firmas.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.sectionHeading}>
        <h2>Firmas de la evaluación</h2>
      </div>
      <div className={styles.signatures}>
        {firmas.map(firma => (
          <div key={firma.rol}>
            {firma.url !== null && (
              <ImagenFirma
                key={`${evaluacion.id}-${firma.tipoFirma}`}
                evaluacionEmpleadoID={evaluacion.id}
                tipoFirma={firma.tipoFirma}
                rol={firma.rol}
              />
            )}
            <div className={styles.signatureCaption}>
              <strong>{firma.usuarioID}</strong>
              <span>{firma.rol}</span>
            </div>
            {firma.url === null && (
              <Button className={styles.signButton} icon={<EditOutlined />} onClick={() => onFirmar(firma)}>
                Firmar {firma.rol.toLowerCase()}
              </Button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
